export const PAGE_MAX_WIDTH = 1300
